import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN, MEDIA_QUERY_LARGE_SCREEN_1080 } from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrText from 'client/components/SrText';
import SrInfoDropdownController from 'client/components/SrInfoDropdownController/SrInfoDropdownController';

const PartnerAgentOwnerMarketingPageFAQs = () => {
  const frequentlyAskedQuestions = [
    {
      title: 'Does it cost extra to use this tool?',
      description: 'No, there are no additional fees for using this service. ' +
        'You\'ll pay the amount in your listing agreement.',
    },
    {
      title: 'Will you take photos of my home?',
      description: 'Yes, we can take brand new professional photos. Or you can use photos you already have.',
    },
    {
      title: 'Where will my property be marketed?',
      description: 'Your property is marketed on Zillow, Realtor.com, MLS, ' +
        'Sunroom Rentals, and many more. It will reach thousands of renters browsing locally.',
    },
    {
      title: 'When is the best time to start marketing my home?',
      description: 'If you\'re trying to reduce vacancy as much as possible, we recommend to ' +
        'start marketing it 30-60 days before it\'s vacant. Or feel free to wait until the existing ' +
        'tenants have moved out, and the property has been turned.',
    },
    {
      title: 'How will I collect the security deposit?',
      description: 'You have the option of connecting a debit card and bank account to ' +
        'have the payments sent directly to you. Alternatively, the system can facilitate ' +
        'the collection of a physical check to your address.',
    },
    {
      title: 'How does the lease get signed?',
      description: 'You and the renters will be invited to sign the lease on DocuSign. ' +
        'You can use the standard TAR agreement or a custom lease.',
    },
    {
      title: 'How do move-in\'s work?',
      description: 'The day the lease is signed, you or your property manager will be connected ' +
        'with the renters. The day of the move-in, the renter will be provided a code to a combo ' +
        'lockbox at the property, so they can access the key.',
    },
    {
      title: 'Why is Sunroom popular for leasing?',
      description: 'Sunroom\'s system has signed thousands of leases. It\'s used by top performing real ' +
        'estate agents to effectively lease their clients\' homes.',
    },
  ];

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const isLargeScreen = useMediaQuery({
    query: MEDIA_QUERY_LARGE_SCREEN_1080,
  });

  return (
    <SrBox padding={isSmallScreen ? '134px 0 0' : '156px 0 0'} maxWidth='1160px' margin='0 auto'>
      <SrText
        font='greycliff'
        color='blueGreycliff'
        size={isSmallScreen ? '40' : '48'}
        lineHeight={isSmallScreen ? '56px' : '60px'}
        weight='700'
        align='center'
        display='block'
      >
        Frequently Asked Questions
      </SrText>
      <SrBox marginTop={isSmallScreen ? '32px' : '78px'}>
        <SrGridRow
          columns={isLargeScreen ? 1 : 2}
          columnGap='40px'
          rowGap={isSmallScreen ? '8px' : '32px'}
          maxWidth='100%'
        >
          {frequentlyAskedQuestions.map((faq) => {
            const { title, description } = faq;
            return (
              <SrInfoDropdownController
                title={title}
                description={description}
              />
            );
          })}
        </SrGridRow>
      </SrBox>
    </SrBox>
  );
};

PartnerAgentOwnerMarketingPageFAQs.displayName = 'PartnerAgentOwnerMarketingPageFAQs';

export default PartnerAgentOwnerMarketingPageFAQs;
